import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import AuthPage from "./pages/AuthPageCustomerSvc";
import { msalInstance } from "./utils/auth/AuthProvider";
import Header from "./components/header/Header";
import Providers from "./providers";

export default function AuthKulcsUzlet({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <MsalProvider instance={msalInstance}>
      <Providers>
        <AuthenticatedTemplate>
          <Header />
          {children}
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <AuthPage />
        </UnauthenticatedTemplate>
      </Providers>
    </MsalProvider>
  );
}
